import { DocumentViewer } from '@pelicargo/types';
import { useMemo } from 'react';

import { useAuth } from '../auth/useAuth';
import { useTargetAccount } from '../useTargetAccount';

/**
 * The viewer identity `modelUtils.document.canManage` needs: the account being acted as, plus the signed-in
 * user (an upload made with no target account selected belongs to its author, not to an account).
 *
 * `isStaff` is deliberately left unset. The client can't establish CS membership trustworthily, so
 * the UI stays conservative and simply doesn't offer the staff-only overrides; the API decides those.
 */
export const useDocumentViewer = (): DocumentViewer => {
  const { targetAccount } = useTargetAccount();
  const { user } = useAuth();

  return useMemo(() => ({ accountId: targetAccount?.id, userId: user?.id }), [targetAccount?.id, user?.id]);
};
